var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-icon',{attrs:{"small":"","color":_vm.color},on:{"click":_vm.onClick}},[_vm._v("mdi-minus")])
}
var staticRenderFns = []

export { render, staticRenderFns }